import { AdminResetUserPasswordResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../../../../../services/core-api-service";

class ResetPasswordDialogService {
    public async resetUserPassword(userId: string): Promise<AdminResetUserPasswordResult> {
        return api.admin.resetUserPassword(userId, {})
    }
}

export const service = new ResetPasswordDialogService()